import { render, staticRenderFns } from "./userProfileCard.vue?vue&type=template&id=9f429e12&"
import script from "./userProfileCard.vue?vue&type=script&lang=js&"
export * from "./userProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports